import { formatRemainingCapacity, getFillColor } from '../../utils/timeBlockCapacity';

export default function BlockCapacityBar({
  fillPercentage,
  remainingMinutes,
  isOverbooked,
  showLabel = true,
  size = 'default' // 'small' | 'default'
}) {
  const fillColor = getFillColor(fillPercentage, isOverbooked);
  const height = size === 'small' ? 'h-1.5' : 'h-2';

  return (
    <div className="w-full">
      {/* Progress bar */}
      <div className={`w-full ${height} bg-surface-hover rounded-full overflow-hidden`}>
        <div
          className="h-full rounded-full transition-all duration-300"
          style={{
            width: `${Math.min(fillPercentage, 100)}%`,
            backgroundColor: fillColor
          }}
        />
      </div>

      {/* Label */}
      {showLabel && (
        <div className="flex justify-between items-center mt-1">
          <span className="text-[10px] text-text-muted">
            {fillPercentage}% full
          </span>
          <span
            className="text-[10px] font-medium"
            style={{ color: fillColor }}
          >
            {formatRemainingCapacity(remainingMinutes)}
          </span>
        </div>
      )}
    </div>
  );
}
